import React from 'react';
import ReactHtmlParser from "react-html-parser";
import { withLocalize } from 'react-localize-redux';
import ModalInner from '../layoutItems/modalInner';

import './searchTip.scss';

class SearchTipPopup extends React.Component {
    render() {
        return (
            <ModalInner 
                title={`${this.props.name}${this.props.hideExtendedTitle === true ? '' : this.props.translate('SearchTips.Title')}`} 
                close={this.props.close}
            >
                <div className="search-tip-popup-content content">
                    {ReactHtmlParser(this.props.bodyHtml)}
                </div>
            </ModalInner>
        )
    }
}

export default withLocalize(SearchTipPopup);
